import parseError from '../../lib/parseError'
import { RECEIVE_CENSUS_ERROR } from './consts'

export default function receiveCensusError(error) {
  const { generalError, resourceErrors } = parseError(error)

  return { type: RECEIVE_CENSUS_ERROR, generalError, resourceErrors }
}
